module.exports = {
    REACT_APP_API_URL: 'https://api.example.com',
    REACT_APP_ENV: 'production',
    ENCRYPTION_KEY : 'your-secret-key'
  };